// extracted by mini-css-extract-plugin
module.exports = {"custom_disabled":"GlobalStatusActionBtn_custom_disabled__2oeeR","allButtons":"GlobalStatusActionBtn_allButtons___uVv0"};